module.exports = __webpack_public_path__ + "assets/img/ZT598M-M.34d93074.png";